import React from "react"
import { IPaymentLinkSupportedPaymentType } from "../../type/paymentPage/IPaymentPageData"
import "./CreditCardPaymentTypeIcon.scss"
import { useTranslation } from "react-i18next"
import { getLogoByCardType } from "../../services/logoService"
import cn from "classnames"

export interface IA2APaymentTypeIconProps {
    paymentTypeData: IPaymentLinkSupportedPaymentType
}

export const CreditCardPaymentTypeIcon = ({ paymentTypeData }: IA2APaymentTypeIconProps) => {
    const { t } = useTranslation()
    if (paymentTypeData.paymentType !== "CreditCard") {
        return null
    }

    const supportedCardBrands = paymentTypeData.configuration.supportedCardBrands ?? []
    return (
        <div className="payment-credit-card-logos">
            {supportedCardBrands
                .map((card) => ({ type: card, url: getLogoByCardType(card, true) }))
                .filter((config) => !!config.url)
                .map((config) => {
                    return (
                        <img
                            key={config.type}
                            className={cn("credit-card-logo", `credit-card-logo__${config.type}`)}
                            src={config.url}
                        ></img>
                    )
                })}
        </div>
    )
}

export default CreditCardPaymentTypeIcon
